import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const header = {
  "Content-Type": "application/x-www-form-urlencoded",
  //   "access-control-allow-origin": "*",
};

const getSupportForumList = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETSUPPORTFORUMLIST, params);
  return data;
};
const supportFormStatusUpdate = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.SUPPORTFORMSTATUSUPDATE,
    params
  );
  return data;
};
const addSupportForum = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.ADDSUPPORTFORUM,
    params,
    header
  );
  return data;
};
const editSupportForum = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.EDITSUPPORTFORUM,
    params,
    header
  );
  return data;
};
const supportForumDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.SUPPORTFORUMDETAILS, params);
  return data;
};

const supportForumSerive = {
  getSupportForumList,
  supportFormStatusUpdate,
  addSupportForum,
  editSupportForum,
  supportForumDetail,
};

export default supportForumSerive;
